const Popup = ({ children }) => {
  return <div className="popup">{children}</div>;
};

export default Popup;
